export interface IOverrideAddress {
    street: string,
    city: string,
    state: string,
    postalCode: string
}